export abstract class BaseError extends Error {
  public data: Record<string, unknown>;

  constructor(message: string, data: Record<string, unknown> = {}) {
    super(message);

    this.name = new.target.prototype.constructor.name;
    Object.setPrototypeOf(this, new.target.prototype);

    this.data = data;
  }
}
